import { FETCH_ALL_PARAMS } from 'constants/query';
import { useMemo } from 'react';
import { configureTableColumns } from 'utils/table-helpers';
import { useGetNestedProductCategoriesQuery } from '../services';
import { NESTED_PRODUCT_CATEGORY_STATUS } from '../constants/status';
import { NestedProductCategoriesColumns, useNestedProductCategoryTableColumns } from '../constants/table-settings';
import useTable from 'hooks/useTable';

const useController = () => {
    const { data: nestedProductCategories } = useGetNestedProductCategoriesQuery(FETCH_ALL_PARAMS);

    const filterSelectOptions = useMemo(() => {
        if (!nestedProductCategories) return;

        return {
            isActive: [
                { value: 'true', label: NESTED_PRODUCT_CATEGORY_STATUS.ACTIVE },
                { value: 'false', label: NESTED_PRODUCT_CATEGORY_STATUS.INACTIVE },
            ],
        };
    }, [nestedProductCategories]);

    const { tableSettings } = useTable<NestedProductCategoriesColumns>({
        columns: configureTableColumns(useNestedProductCategoryTableColumns(), filterSelectOptions || {}),
        queryIdentifier: 'nestedProductsCategories',
    });

    return {
        tableSettings,
    };
};

export default useController;
